import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargePermittedActionsResponse from "./chargePermittedActionsResponse";
import ChargeRefundResponse from "./chargeRefundResponse";
import ChargeRefundationStatus from "./chargeRefundationStatus";
import NotificationPreferencesResponse from "./notificationPreferencesResponse";
import SourceType from "./sourceType";
import VehicleRegistrationResponse from "./vehicleRegistrationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeDetailResponse {
  /**
   * Unique ID of a charge.
   */
  id!: string;

  /**
   * Charge order confirmed at.
   */
  @observable
  @Type(() => Date)
  chargeOrderConfirmedAt!: Date;

  @observable
  chargeOrderSourceType!: SourceType;

  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => VehicleRegistrationResponse)
  vehicle!: VehicleRegistrationResponse;

  /**
   * Beginning date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Authentication code.
   */
  @observable
  authCode!: string;

  /**
   * Customer's email address for payment confirmations and payment instructions.
   */
  @observable
  emailAddress?: string;

  @observable
  @Type(() => NotificationPreferencesResponse)
  notificationPreferences!: NotificationPreferencesResponse;

  @observable
  @Type(() => ChargeRefundResponse)
  refund?: ChargeRefundResponse;

  @observable
  refundationStatus!: ChargeRefundationStatus;

  /**
   * Link to e-shop for a new charge purchase of the same type.
   */
  @observable
  newChargePurchaseUrl?: string;

  @observable
  @Type(() => ChargePermittedActionsResponse)
  permittedActions!: ChargePermittedActionsResponse;

  // FE only attributes
  @Type(() => VehicleRegistrationResponse)
  @observable
  newVehicle: VehicleRegistrationResponse = new VehicleRegistrationResponse();

  @observable
  @Type(() => Date)
  newValidSince!: Date;

  /**
   * End date and time of charge validity.
   */
  @observable
  @Type(() => Date)
  newValidUntil!: Date;

  @observable
  _canBeChanged: boolean;

  @observable
  _chargeTypeId: string;

  @observable
  _fuelTypeId: string;
}
